import { useTheme } from "@emotion/react";
import { Button, Paper } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { WebContentTimes } from "../../utilities/Enum";

const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 22px;
`;
const PreviewImage = styled("div")({
  marginInline: "50px",
  border: " 1px dashed rgba(0, 0, 0, 0.05)",
  borderRadius: "12px",
  width: "300px",
  height: "200px",
  position: "relative",
  cursor: "pointer",
  overflow: "hidden",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  "&:hover": {
    "& .upload-overlay": {
      opacity: 1,
    },
    "& .remove-overlay": {
      opacity: 1,
    },
  },
});

const WebContentInfo = ({ webContentInfo }) => {
  let theme = useTheme();
  let navigate = useNavigate();
  const { id } = useParams();
  const [previewUrl, setPreviewUrl] = useState();

  useEffect(() => {
    setPreviewUrl(webContentInfo?.photoUrl);
  }, [webContentInfo]);

  return (
    <Paper
      elevation={0}
      // square
      sx={{
        p: 2,
        mt: 1,

        background: theme.color.PaperbgColor,
        width: "60%",
      }}>
      <div style={{ textAlign: "right" }}>
        <Button
          sx={{
            background: theme.color.blackBackground,
            color: "white",
            "&:hover": { background: `${theme.color.black}` },
          }}
          onClick={() => navigate(`/sites/SiteDetail/${id}/UpdateWebClient`)}>
          Edit
        </Button>
      </div>
      <div style={{ display: "flex" }}>
        <Grid2>
          <span
            style={{ color: theme.color.PaperlabelColor, fontSize: "14px" }}>
            Caption
          </span>
          <span>{webContentInfo?.caption}</span>
          <span
            style={{ color: theme.color.PaperlabelColor, fontSize: "14px" }}>
            Left Text
          </span>
          <span>{webContentInfo?.leftText}</span>
          <span
            style={{ color: theme.color.PaperlabelColor, fontSize: "14px" }}>
            Right Text
          </span>
          <span>{webContentInfo?.rightText}</span>
          <span
            style={{ color: theme.color.PaperlabelColor, fontSize: "14px" }}>
            Show Price
          </span>
          <span>
            {webContentInfo?.showPrice === 0 && <span>No Price</span>}
            {webContentInfo?.showPrice === 1 && <span>Official Price</span>}
            {webContentInfo?.showPrice === 2 && <span>Trial Price</span>}
          </span>
        </Grid2>
        <PreviewImage>
          {previewUrl && <img alt="site-background" src={previewUrl} />}
        </PreviewImage>
      </div>
      <div style={{ marginTop: "16px" }}>
        <Grid2>
          <span
            style={{
              color: theme.color.PaperlabelColor,
              fontSize: "14px",
              marginBottom: "4px",
            }}>
            Display Time
          </span>
          <span>
            {(webContentInfo?.times || [])
              .map(
                (timeId) =>
                  WebContentTimes?.find((o) => o.id === timeId)?.label,
              )
              .filter(Boolean)
              .join(", ") || "—"}
          </span>
        </Grid2>
      </div>
    </Paper>
  );
};

export default WebContentInfo;
